import src from "IMAGE";
export default { src, width: 640, height: 512, blurWidth: 0, blurHeight: 0};
